import { indexes } from '@mab-common/utils'

import type { QueryDslQueryContainer } from '@elastic/elasticsearch/lib/api/types'

import Loader from '~/components/atoms/Loader/Loader'
import { ProfileImageType } from '~/components/atoms/ProfileImage/ProfileImage'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'
import { useArtworksCatalogue } from '~/services/query'

import Catalogue from '../Catalogue/Catalogue'

import styles from './AllArtworksCatalogue.module.css'
import RecordTypes = indexes.RecordTypes

export interface AllArtworksCatalogueProps {
  total: number
  filterQueries?: QueryDslQueryContainer[]
  testID?: string
  searchInsightsEvent?: TSearchAnalystEventProps
}

export default function AllArtworksCatalogue({
  total,
  filterQueries = [],
  testID,
  searchInsightsEvent,
}: AllArtworksCatalogueProps) {
  const { data, insightsQueryID } = useArtworksCatalogue(
    filterQueries,
    // elastic can respond only 10_000 for now
    total > 0 && total < 10000 ? total : 6000
  )

  return data ? (
    <Catalogue
      items={data}
      insightsQueryID={insightsQueryID}
      type={ProfileImageType.Artwork}
      className={styles.noPadding}
      showNumberOfWorks={false}
      searchInsightsEvent={searchInsightsEvent}
      recordType={RecordTypes.ARTWORK}
    />
  ) : (
    <Loader testID={testID && `loader-${testID}`} />
  )
}
